<template>
    <AppLayoutRoot :default-layout="Layout.Sidebar">
        <div
            id="app"
            :class="userStore.type"
        >
            <router-view />
            <UiLoading
                :active="popup.loader.isVisible"
                :full-page="true"
            />
            <ChatBaseWidget v-if="userStore.user" />
        </div>
    </AppLayoutRoot>

    <DialogsMountingPoint />

    <Toaster
        rich-colors
        position="top-center"
        :duration="5000"
    />
</template>

<script lang="ts" setup>
    import usePopup from '@/composables/usePopup';
    import { useUserStore } from '@/stores/user.store';
    import 'vue-sonner/style.css';
    import { Toaster } from '@/shared/ui/Sonner';
    import { DialogsMountingPoint } from '@/shared/ui/Dialog';
    import { AppLayoutRoot, Layout } from '@/core/layout';

    import UiLoading from '@/components/Global/UiLoading/UiLoading.vue';
    import ChatBaseWidget from '@/components/ChatBase/ChatBaseWidget.vue';

    const userStore = useUserStore();
    const popup = usePopup();
</script>
